import { createSelector } from "reselect";

const selectEntity = state => state.entities.image;
const selectEntityData = state =>
  state.entities.image ? Object.values(state.entities.image.data) : [];

export const makeSelectImage = () =>
  createSelector([selectEntityData], substate => substate);

export const makeSelectImageLoading = () =>
  createSelector(selectEntity, substate => {
    if (substate) return substate.isLoading;
    return false;
  });
